import React, { useState, Fragment } from 'react'
import styled from 'react-emotion'
import ReactMarkdown from 'react-markdown'
import { ProgressiveBackground, ga, Modal } from '../../../application'
import { colors } from '../../../styles'

const Container = styled('div')`
    display: flex;
    flex-direction: column;    
    background-color: ${colors.tui_white};
    margin-bottom: 10px;
    height: 250px;
    border-radius: 4px;
    overflow: hidden;
    border: 0;
    box-shadow: 0 2px 5px 0 rgba(0,0,0,.1);
    width: calc(25% - 20px);
    margin: 0 10px 12px;
    cursor: pointer;
    @media (max-width: 992px){
        width: calc(50% - 20px);
    }
`

const ImageContainer = styled('div')`
    height: auto;
`

const Content = styled('div')`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 10px;
    height: 100px;
`

const ArticleContent = styled('div')`
    margin-top: 20px;
`

const InspirationCard = ({ article, userId }) => {
    const [showArticle, setShowArticle] = useState(false)

    const renderArticleModal = () => (
        <Modal open={showArticle} onClose={() => setShowArticle(false)} width={"800px"} padding={'0px'}>
            <h1>{article.header}</h1>
            {article.image && (
                <ProgressiveBackground src={article.image.url} imageParams={'w=1280'} className="ratio-16-9" alt={article.image.alt} />
            )}
            <ArticleContent>
                <ReactMarkdown source={article.description} linkTarget="_blank" />
            </ArticleContent>
        </Modal>
    )

    const handleLinkClick = (e) => {
        ga.push({
            'eventCategory': 'swirep',
            'eventAction': 'click',
            'eventLabel': `inspiration-destination-[${userId}]-[${article.id}]`,
            'event': 'genericTrackEvent'
        })
        setShowArticle(true)
    }

    return (
        <Fragment>
            {showArticle && renderArticleModal()}
            <Container onClick={handleLinkClick}>
                <ImageContainer>
                    {article.image && <ProgressiveBackground src={article.image.url} imageParams={'w=640'} className="ratio-16-9" alt={article.image.alt} />}
                </ImageContainer>
                <Content>
                    <h4>{article.header}</h4>
                    <p>{article.teaser}</p>
                </Content>
            </Container>
        </Fragment>
    )
}

export default InspirationCard